import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import DestinationsMobile from "Assets/images/destinationsMobile.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const DestinationsMobileIcon: FC<Props> = memo(
  ({ onClick, className }: Props) => {
    const classes = createUseStyles(styles)();
    const click = (e: any) => {
      e.preventDefault();
      if (onClick) onClick(e);
    };
    return (
      <DestinationsMobile
        id="destinationMobileIcon"
        className={`${classes.pointer} ${className || ""}`}
        onClick={click}
      />
    );
  },
  areEqualShallow
);
DestinationsMobileIcon.defaultProps = {
  className: undefined,
};
export default DestinationsMobileIcon;
